import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from "react";
import { useI18N } from "../context/I18NContext";
const SuccessAlert = ({ messages, setter }) => {
    const { t } = useI18N();
    const [successes, setSuccesses] = useState();
    useEffect(() => {
        setSuccesses(messages);
        setTimeout(() => {
            setSuccesses(undefined);
            if (setter)
                setter(undefined);
        }, 5000);
    }, [messages]);
    return (_jsx(Collapse, { in: !!successes, children: _jsx(Alert, { sx: { my: 2 }, severity: "success", onClose: () => {
                setSuccesses(undefined);
                if (setter)
                    setter(undefined);
            }, children: successes === null || successes === void 0 ? void 0 : successes.map((_success, i) => (_jsx(Typography, { children: t(_success) }, i))) }) }));
};
export default SuccessAlert;
